import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

// interface Card {
//   authorName?: string;
//   createTimeStr?: string;
//   title?: string;
//   commentCount?: number;
// }

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'icc-comment-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .card-wrapper {
        background-color: white;
        padding: 17px 15px;
        position: relative;
        overflow: hidden;
        margin: 0 auto;
        /* border-top: 1px solid gainsboro; */
        border-bottom: 1px solid gainsboro;
        cursor: pointer;
      }
      .card-wrapper:hover {
        background-color: #ebf8fe;
      }
      .card-wrapper.active {
        background-color: #ebf8fe;
      }
      .card-content {
        position: relative;
        height: 100%;
      }
      .card-wrapper p {
        margin: 0;
        color: #a6acc5;
        font-size: 14px;
      }
      .title {
        font-weight: bold;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-size: 13px;
      }
      .author {
        text-align: right;
      }
      .total {
        float: left;
        width: 39%;
      }
      time {
        float: right;
        width: 60%;
        text-align: right;
      }
      .top {
        position: absolute;
        top: 0;
        width: 100%;
        left: 0;
      }
      .bottom {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
      }
    `,
  ],
  template: `
    <div class="card-wrapper" [ngStyle]="{ width: width + 'px', height: height + 'px' }" [ngClass]="{ active: active }" (click)="cardClick()">
      <div class="card-content">
        <div class="top">
          <h2 class="title">{{ card.title }}</h2>
        </div>
        <div class="bottom">
          <p class="author">{{ card.authorName }}</p>
          <p>
            <span class="total">总评论数：{{ card.commentTotalCount }}</span>
            <time>{{ card.createTime }}</time>
          </p>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
})
export class IccCommentCardComponent {
  /**
   * 卡片对象
   * - `author` 作者
   * - `createTimeStr` 创建时间
   * - `title` 标题
   * - `commentCount` 总评论数
   */
  // @Input() card: Card = {};
  @Input() card: any;
  /** 选中状态 */
  @Input() active = false;
  /** 卡片宽度 */
  @Input() width = 280;
  /** 卡片高度 */
  @Input() height = 130;
  /** 卡片宽度 */
  @Output() clickHandle = new EventEmitter<any>();

  cardClick() {
    this.clickHandle.next();
  }
}
